import { render, staticRenderFns } from "./UserBar.vue?vue&type=template&id=70871e4e&scoped=true"
import script from "./UserBar.vue?vue&type=script&lang=js"
export * from "./UserBar.vue?vue&type=script&lang=js"
import style0 from "./UserBar.vue?vue&type=style&index=0&id=70871e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70871e4e",
  null
  
)

export default component.exports